import { css } from '@emotion/css';

import { Spacing } from 'apps/shared/scripts/styles/constants';

export const cardDeliveryFooterClassName = css({
  marginTop: Spacing['2XL'],
});
